var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"dense":"","solo":""},on:{"blur":_vm.validateDate},model:{value:(_vm.displayDate),callback:function ($$v) {_vm.displayDate=$$v},expression:"displayDate"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }